import { Alert, Grid, TextField } from '@mui/material'
import React from 'react'

import { formatCode } from 'components/common/CodeBlock'
import { type AuthenticationResponse } from 'context/status-checks/ObservabilityToolAuthenticationContext'
import { isValidStatusCodeOrRange } from 'utils/team-external-integrations/team-external-integrations-util'

export const ObservabilityToolAuthenticationStatus: React.FC<{
  authenticationResponse: AuthenticationResponse
}> = ({ authenticationResponse }) => {
  const { alertSeverity, httpStatusCode, responseBody, message } =
    authenticationResponse

  if (!alertSeverity) {
    return null
  }

  const isBodyContentTypeHtml =
    authenticationResponse?.contentType?.includes('html')

  return (
    <Grid container direction="column" rowSpacing={2}>
      {alertSeverity && (
        <Grid item>
          <Alert
            data-testid="test-status-check-integration-alert"
            severity={alertSeverity}
          >
            {message}
          </Alert>
        </Grid>
      )}
      {!isValidStatusCodeOrRange(httpStatusCode) &&
        alertSeverity === 'error' && (
          <Grid item>
            <TextField
              contentEditable={false}
              data-testid="test-status-check-integration-response-code"
              disabled={true}
              fullWidth={true}
              InputProps={{ sx: { fontFamily: 'Monaco' } }}
              label="Response Code"
              sx={{ fontFamily: 'Sohne Mono' }}
              value={httpStatusCode}
            />
          </Grid>
        )}
      {Boolean(responseBody) &&
        !isBodyContentTypeHtml &&
        alertSeverity === 'error' && (
          <Grid item>
            <TextField
              multiline
              contentEditable={false}
              data-testid="test-status-check-integration-response-body"
              disabled={true}
              fullWidth={true}
              InputProps={{ sx: { fontFamily: 'Monaco' } }}
              label="Response Body"
              maxRows={8}
              sx={{ fontFamily: 'Sohne Mono' }}
              value={formatCode(null, responseBody)}
            />
          </Grid>
        )}
    </Grid>
  )
}
